import Modal, { Styles } from "react-modal";
import ClipLoader from "react-spinners/ClipLoader";
import { selectRoles } from "../../common/commonSlice";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import {
  getAsesores,
  selectAsesores,
} from "../../services/analytics/analyticsSlice";
import {
  changeActiveComponent,
  getAllUsers,
  getAuthConfig,
  selectActiveConfigurationComponent,
  selectAllUsers,
  selectTokenConfig,
  selectTokenConfigLoading,
  selectUsersLoading,
  updateAuthConfig,
} from "../configurationSlice";
import { useEffect, useState } from "react";
import { formateDateRelativeToNow } from "../../../helpers/utils";
import { ClientTokenConfig } from "../configurationAPI";
import { DropDown } from "../../common/components/Btns/DropDown";
Modal.setAppElement("#root");

const customStylesModal: Styles = {
  content: {
    top: "50%",
    left: "60%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    background: "rgba(255,255,255,1)",
    borderRadius: "20px",
    boxSizing: "border-box",
    padding: "1.2%",
    width: "35%",
    overflow: "auto",
    height: "30%",
  },
  overlay: {
    background: "rgba(0,0,0,0.3)",
  },
};
export const OfflineConfig = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const asesores = useAppSelector(selectAsesores);
  const allUsers = useAppSelector(selectAllUsers);
  const roles = useAppSelector(selectRoles);
  const activeComponent = useAppSelector(selectActiveConfigurationComponent);
  const usersLoading = useAppSelector(selectUsersLoading);
  const tokenConfigLoading = useAppSelector(selectTokenConfigLoading);
  const tokenConfig = useAppSelector(selectTokenConfig);

  const [modalChangeTokenSessionOpen, setModalChangeTokenSessionOpen] =
    useState(false);

  const [newSessionTokenMinutes, setNewSessionTokenMinutes] = useState(0);
  const [newSessionTokenHours, setNewSessionTokenHours] = useState(0);

  const getUsersWithOfflineAccess = () => {
    if (allUsers && allUsers.length > 0) {
      //filter user with offline access
      return allUsers.filter(
        (user) => user.roles.includes("coreid.offline") === true
      );
    } else {
      return [];
    }
  };

  const getSessionFormatter = (tokenConfig: ClientTokenConfig | null) => {
    if (!tokenConfig) {
      return "";
    }
    const durationInMinutes = tokenConfig.defaultTokenExpirationMinutes;
    // convert the  durationInMinutes to hours and minutes
    const hours = Math.floor(durationInMinutes / 60);
    const minutes = durationInMinutes % 60;
    return `${hours}h ${minutes}m`;
  };

  const getHourOptions = () => {
    const options: { value: string; label: string }[] = [];
    for (let i = 0; i <= 120; i++) {
      options.push({ value: i.toString(), label: i.toString() });
    }
    return options;
  };

  const getMinutesOptions = () => {
    const options: { value: string; label: string }[] = [];
    for (let i = 0; i <= 59; i++) {
      options.push({ value: i.toString(), label: i.toString() });
    }
    return options;
  };

  useEffect(() => {
    if (activeComponent !== "Offline") {
      dispatch(changeActiveComponent("Offline"));
    }
    if (allUsers.length === 0) {
      dispatch(getAllUsers());
    }
    if (asesores.length === 0) {
      dispatch(getAsesores());
    }
    if (tokenConfigLoading === "idle") {
      dispatch(getAuthConfig()).then(() => {
        const hours = Math.floor(
          tokenConfig.defaultTokenExpirationMinutes / 60
        );
        const minutes = tokenConfig.defaultTokenExpirationMinutes % 60;
        setNewSessionTokenHours(hours);
        setNewSessionTokenMinutes(minutes);
      });
    }
  }, []);

  if (usersLoading === "pending") {
    return (
      <div
        style={{
          width: "100%",
          height: "90%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: "1%",
        }}
      >
        <ClipLoader color="#FFF" size={"200px"} />
      </div>
    );
  } else {
    return (
      <div className="flex-col" style={{ width: "100%", height: "100%" }}>
        <Modal
          shouldCloseOnEsc
          shouldCloseOnOverlayClick
          shouldFocusAfterRender
          shouldReturnFocusAfterClose
          style={customStylesModal}
          isOpen={modalChangeTokenSessionOpen}
          onRequestClose={() => {
            setModalChangeTokenSessionOpen(false);
          }}
        >
          <div
            className="flex-col"
            style={{
              alignItems: "center",
              width: "100%",
              height: "100%",
              justifyContent: "space-between",
            }}
          >
            <div
              className="text-large text-bold"
              style={{ textAlign: "center", fontSize: "18px" }}
            >
              Modificación vigencia sesión
            </div>
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
                margin: "10px 0 0 0",
              }}
            >
              <p
                style={{
                  fontSize: "15px",
                  color: "black",
                  fontWeight: "500",
                  marginBottom: "0px",
                }}
              >
                Seleccione a continuación la nueva duración de la sesión.
              </p>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginTop: "12px",
                  marginBottom: "15px",
                  width: "100%",
                  alignItems: "center",
                  justifyContent: "space-evenly",
                }}
              >
                <DropDown
                  key={"hours"}
                  title={"Horas"}
                  options={getHourOptions()}
                  titleColor="black"
                  makeMinWidth
                  isClearable={false}
                  defaultValue={{
                    value: newSessionTokenHours.toString(),
                    label: newSessionTokenHours.toString(),
                  }}
                  bgColor="#1a617d"
                  onChange={(e) => {
                    if (!e || e?.value === undefined) {
                      setNewSessionTokenHours(0);
                    }
                    if (e?.value === "") {
                      setNewSessionTokenHours(0);
                    } else {
                      setNewSessionTokenHours(parseInt(e?.value));
                    }
                  }}
                />
                <DropDown
                  key={"minutes"}
                  title={"Minutos"}
                  options={getMinutesOptions()}
                  titleColor="black"
                  makeMinWidth
                  isClearable={false}
                  defaultValue={{
                    value: newSessionTokenMinutes.toString(),
                    label: newSessionTokenMinutes.toString(),
                  }}
                  bgColor="#1a617d"
                  onChange={(e) => {
                    if (!e || e?.value === undefined) {
                      setNewSessionTokenMinutes(0);
                    }
                    if (e?.value === "") {
                      setNewSessionTokenMinutes(0);
                    } else {
                      setNewSessionTokenMinutes(parseInt(e?.value));
                    }
                  }}
                />
              </div>
              <p
                style={{
                  fontSize: "15px",
                  color: "black",
                  fontWeight: "500",
                  marginBottom: "0px",
                }}
              >
                Después de aplicar el camibo, <strong>solo</strong> se aplicará
                para nuevos inicios de sesión.
              </p>
            </div>
            <div
              className="flex-row"
              style={{
                width: "90%",
                justifyContent: "space-evenly",
                alignItems: "center",
                marginTop: "15px",
              }}
            >
              <button
                onClick={(e) => {
                  e.preventDefault();
                  setModalChangeTokenSessionOpen(false);
                  const hours = Math.floor(
                    tokenConfig.defaultTokenExpirationMinutes / 60
                  );
                  const minutes =
                    tokenConfig.defaultTokenExpirationMinutes % 60;
                  setNewSessionTokenHours(hours);
                  setNewSessionTokenMinutes(minutes);
                }}
                className="flex-col text-medium text-bold"
                style={{
                  background: "transparent",
                  width: "35%",
                  height: "40px",
                  textAlign: "center",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "8px",
                  border: "1px solid #1A617D",
                  color: "#1A617D",
                }}
              >
                Cerrar ventana
              </button>
              <button
                disabled={false}
                onClick={(e) => {
                  e.preventDefault();
                  const req: ClientTokenConfig = {
                    defaultTokenExpirationMinutes:
                      newSessionTokenMinutes + newSessionTokenHours * 60,
                  };
                  dispatch(updateAuthConfig(req)).then(() => {
                    setModalChangeTokenSessionOpen(false);
                  });
                }}
                className="flex-col text-medium text-bold primary-color"
                style={{
                  background: "#1A617D",
                  width: "35%",
                  height: "40px",
                  textAlign: "center",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "8px",
                  border: "none",
                }}
              >
                {tokenConfigLoading === "pending" ? (
                  <ClipLoader color="white" size={"20px"} />
                ) : (
                  "Confirmar"
                )}
              </button>
            </div>
          </div>
        </Modal>
        <div
          className="flex-row"
          style={{
            height: "2%",
            justifyContent: "space-between",
            alignItems: "start",
            margin: "1% 1% 1% 1%",
          }}
        >
          <div
            className="text-xx-large text-bold primary-color"
            style={{ margin: "0 0 0 2%" }}
          >
            Configuración CoreId Offline
          </div>
        </div>
        <div
          style={{
            width: "99.5%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              marginBottom: "1%",
            }}
          >
            <div
              style={{
                width: "52%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <div
                className="flex-col"
                style={{ height: "85%", margin: "1% 1% 0 0 " }}
              >
                <p
                  className="text-medium text-semibold primary-color"
                  style={{ margin: "2% 0 2% 1.2%" }}
                >
                  Los siguientes usuarios tienen aceceso a la aplicación de
                  CoreId Offline
                </p>
                <div style={{ overflow: "auto" }}>
                  <table
                    style={{
                      width: "98%",
                      borderCollapse: "collapse",
                      marginLeft: "1%",
                    }}
                  >
                    <thead
                      className="text-normal text-medium primary-color-35"
                      style={{
                        background: "rgba(0,0,0,0.4)",
                        height: "30px",
                        textAlign: "center",
                      }}
                    >
                      <tr>
                        <th></th>

                        <th>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            Nombres y Apellidos
                          </div>
                        </th>
                        <th>
                          <div
                            onClick={(e) => {
                              e.preventDefault();
                            }}
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            Email
                          </div>
                        </th>
                        <th>Estado</th>
                        <th>Último inicio de sesión</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody
                      className="text-normal text-x-small primary-color"
                      style={{
                        background: "rgba(0,0,0,0.2)",
                        textAlign: "center",
                      }}
                    >
                      <tr>
                        <td>&nbsp;</td> <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      {getUsersWithOfflineAccess().map((usuario, i) => {
                        return (
                          <tr
                            key={i}
                            className="list-hover"
                            style={{ height: "30px", cursor: "pointer" }}
                          >
                            <td></td>
                            <td
                              onClick={(e) => {
                                e.preventDefault();
                                navigate(`/configuration/users/${usuario.id}`);
                              }}
                              style={{
                                textAlign: "left",
                                paddingLeft: "10px",
                              }}
                            >
                              {usuario.name || "NO Registra"}
                            </td>
                            <td
                              onClick={(e) => {
                                e.preventDefault();
                                navigate(`/configuration/users/${usuario.id}`);
                              }}
                              style={{
                                textAlign: "left",
                                paddingLeft: "10px",
                              }}
                            >
                              {usuario.email || "NO Registra"}
                            </td>
                            <td
                              onClick={(e) => {
                                e.preventDefault();
                                navigate(`/configuration/users/${usuario.id}`);
                              }}
                            >
                              {usuario.active === true ? "Activo" : "Inactivo"}
                            </td>

                            <td
                              onClick={(e) => {
                                e.preventDefault();
                                navigate(`/configuration/users/${usuario.id}`);
                              }}
                            >
                              {formateDateRelativeToNow(usuario.latestLogin)}
                            </td>

                            <td></td>
                          </tr>
                        );
                      })}
                      <tr>
                        <td>&nbsp;</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div
              style={{
                width: "47%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "start",
                  width: "100%",
                  marginTop: "10%",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    padding: "8px 0px 8px 0px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    fontSize: "15px",
                    backgroundColor: "rgba(0,0,0,0.4)",
                    color: "rgba(255,255,255, 0.8)",
                    borderRadius: "8px 8px 0px 0px",
                    fontWeight: "600",
                  }}
                >
                  Configuración
                </div>
                <div
                  style={{
                    width: "100%",
                    padding: "8px 12px 8px 12px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "start",
                    backgroundColor: "rgba(0,0,0,0.2)",
                    borderRadius: "0px 0px 8px 8px",
                  }}
                >
                  {tokenConfigLoading === "pending" ? (
                    <ClipLoader color="#FFF" size="120px" />
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                        justifyContent: "start",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          width: "70%",
                          justifyContent: "start",
                        }}
                      >
                        <div
                          style={{
                            width: "100%",
                            padding: "8px 0px 8px 0px",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            textAlign: "center",
                            fontSize: "15px",
                            backgroundColor: "rgba(0,0,0,0.4)",
                            color: "rgba(255,255,255, 0.7)",
                            borderRadius: "8px 8px 0px 0px",
                            fontWeight: "600",
                          }}
                        >
                          Vigencia de sesión
                        </div>
                        <div
                          style={{
                            width: "100%",
                            padding: "8px 12px 8px 12px",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "start",
                            backgroundColor: "rgba(0,0,0,0.2)",
                            borderRadius: "0px 0px 8px 8px",
                          }}
                        >
                          <p
                            style={{
                              fontSize: "16px",
                              fontWeight: "500",
                              color: "white",
                            }}
                          >
                            La vigencia de una sesión actual es de: <br />
                            <strong>{getSessionFormatter(tokenConfig)}</strong>
                          </p>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              alignSelf: "end",
                              marginTop: "14px",
                            }}
                          >
                            {roles.includes("authConfig.edit") && (
                              <button
                                onClick={(e) => {
                                  e.preventDefault();
                                  const hours = Math.floor(
                                    tokenConfig.defaultTokenExpirationMinutes /
                                      60
                                  );
                                  const minutes =
                                    tokenConfig.defaultTokenExpirationMinutes %
                                    60;
                                  setNewSessionTokenHours(hours);
                                  setNewSessionTokenMinutes(minutes);
                                  setModalChangeTokenSessionOpen(true);
                                }}
                                style={{
                                  padding: "3px 18px",
                                  textAlign: "center",
                                  color: "#FFF",
                                  background: "rgba(0,0,0,0.2)",
                                  borderRadius: "8px",
                                  border: "none",
                                  fontWeight: "600",
                                  fontSize: "15px",
                                }}
                              >
                                Modificar
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          alignSelf: "start",
                          marginTop: "14px",
                        }}
                      >
                        {roles.includes("authConfig.edit") && (
                          <button
                            onClick={(e) => {
                              e.preventDefault();
                              const req: ClientTokenConfig = {
                                defaultTokenExpirationMinutes: 0,
                              };
                              dispatch(updateAuthConfig(req));
                            }}
                            style={{
                              padding: "5px 10px",
                              textAlign: "center",
                              color: "#FFF",
                              background: "rgba(0,0,0,0.2)",
                              borderRadius: "8px",
                              border: "none",
                              maxWidth: "150px",
                              fontWeight: "600",
                              fontSize: "15px",
                            }}
                          >
                            Desactivar Acceso General
                          </button>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
};
